<section class="blog-filter">
  <header class="blog-filter-header">
    <p class="blog-filter-count">
      {{ posts().length }}
      {{ posts().length === 1 ? "post" : "posts" }}
    </p>
  </header>

  @if (hasPosts()) {
    <ol class="blog-filter-list" aria-label="Posts with this tag">
      @for (post of posts(); track post.slug) {
        <li>
          <app-blog-post-card [post]="post" />
        </li>
      }
    </ol>
  } @else {
    <p class="blog-filter-empty">
      No posts with this tag.
      <a routerLink="/blog">Browse all posts</a>
      instead.
    </p>
  }
</section>

<app-page-cta location="bottom" />
